// ACCESS care tracks. Track comes from care_period.track_code / care_plan.track;
// the subtrack id (e.g. "ECKM-04") encodes it as a prefix — the fallback source.
export interface TrackLabel { code: string; display: string }

const TRACK_LABELS: Record<string, TrackLabel> = {
  eckm: { code: 'eCKM', display: 'Early Cardio-Kidney-Metabolic' },
  ckm: { code: 'CKM', display: 'Cardio-Kidney-Metabolic' },
};

// Canonical track key ('eckm' | 'ckm' | …) from a track_code or a subtrack prefix.
export function deriveTrackCode(
  trackCode?: string | null,
  subtrackId?: string | null,
): string | null {
  const raw = (trackCode || '').trim().toLowerCase();
  if (raw) return raw;
  const prefix = (String(subtrackId || '').split('-')[0] || '').trim().toLowerCase();
  return prefix || null;
}

export function formatTrackLabel(
  trackCode?: string | null,
  subtrackId?: string | null,
): TrackLabel | null {
  const key = deriveTrackCode(trackCode, subtrackId);
  if (!key) return null;
  return TRACK_LABELS[key] || { code: key.toUpperCase(), display: key.toUpperCase() };
}
